<template>
  <v-card flat tile class="d-flex" elevation="2">
    <v-btn
      v-if="uploadedImage != null"
      fab
      absolute
      top
      right
      x-small
      color="error"
      @click="
        () => {
          uploadedImage = null;
          $emit('remove');
        }
      "
    >
      <v-icon>mdi-close</v-icon>
    </v-btn>
    <v-hover v-slot="{ hover }">
      <v-img :src="getImage()" :aspect-ratio="aspect_ratio" :height="height">
        <v-row
          v-if="hover"
          class="fill-height ma-0 hoverImage"
          align="center"
          @click="pickFile"
          justify="center"
          style="cursor: pointer"
        >
          <div align="center" justify="center" class="white--text">
            <v-icon color="#fff" large>mdi-pencil</v-icon>
            <div class="pa-2 .title">{{ text }}</div>
          </div>
        </v-row>
      </v-img>
    </v-hover>
    <input
      type="file"
      style="display: none"
      ref="image"
      accept="image/*"
      @change="onFilePicked"
    />
  </v-card>
</template>

<script>
import images from "@/utils/images";
export default {
  props: {
    image_path: { type: String, default: null },
    aspect_ratio: { type: String, default: "1.7" },
    defaultImage: { type: String, default: "default" },
    height: { type: Number, default: 100 },
    text: { type: String, default: "Click to change the image" },
  },
  data() {
    return {
      uploadedImage: null,
    };
  },
  watch: {
    image() {
      this.uploadedImage = null;
    },
    image_path: {
      immediate: true,
      handler() {
        this.uploadedImage = null;
      },
    },
  },
  mounted() {},
  methods: {
    getImage() {
      return this.uploadedImage
        ? this.uploadedImage
        : this.image_path
        ? this.s3BucketURL + this.image_path
        : images[this.defaultImage];
    },
    pickFile() {
      this.$refs.image.click();
    },
    onFilePicked(e) {
      let files = e.target.files;
      if (!files.length) {
        return;
      }
      let reader = new FileReader();
      reader.onload = (e) => {
        this.uploadedImage = e.target.result;
        this.$emit("upload", files[0]);
        this.$emit("result", e.target.result);
      };
      reader.readAsDataURL(files[0]);
    },
  },
};
</script>

<style>
</style>